import { render, staticRenderFns } from "./NovaKomBanksTable.vue?vue&type=template&id=6ddf813e&scoped=true&"
import script from "./NovaKomBanksTable.vue?vue&type=script&lang=js&"
export * from "./NovaKomBanksTable.vue?vue&type=script&lang=js&"
import style0 from "./NovaKomBanksTable.vue?vue&type=style&index=0&id=6ddf813e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf813e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBadge,VBtn,VCol,VDataTable,VIcon,VSpacer,VToolbar,VToolbarTitle})
